import { appEnv } from '@/app/config/env';

import { Analytics } from './instance';

if (import.meta.env.PROD && appEnv.analyticsId) {
  Analytics.initialize(appEnv.analyticsId);
}
